import { Component } from '@angular/core';
import { PanelComponent } from 'src/app/panels/components/panel.component';
import { PIE_PANEL_IMPORTS, PiePanelComponent } from 'src/app/panels/components/pie/pie-panel/pie-panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/pie/pie-panel/pie-panel.component.html',
  styleUrl: '../../../../panels/components/pie/pie-panel/pie-panel.component.scss',
  selector: 'app-grid-vs-solar-pie-panel',
  imports: PIE_PANEL_IMPORTS,
})
export class GridVsSolarPiePanelComponent extends PiePanelComponent {
  public static override readonly type = PanelType.GridVsSolarPie;
  public override title = 'Verbruik uit net vs opgewekt';
  public override icon = 'bi-lightning-charge-fill';
  public override unit = DisplayUnit.Kwh;
  public override colors = [Color.Blue, Color.Green];
}
